import React from 'react';
import moment from 'moment';
import { Button } from 'semantic-ui-react';
import styled from '@emotion/styled';
import EditGuestProfileModal from 'src/containers/guestDashboard/EditGuestProfileModal';
import { GUEST_MISSING_DATA_BUTTON } from './guestIdentity';

const GuestPlainDataWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.75rem;
  width: 100%;

  .info {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    margin: 0;
    width: 100%;
  }

  .profilePhoto {
    flex: 0 0 150px;
    width: 150px;
    height: 150px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 12px;
    border: 1px solid #e0e0e0;
    background-color: #f5f5f5;
    margin: 0;
  }

  .data {
    margin: 0;
    flex: 1;
    min-width: 0;

    &.pic {
      display: flex;
      flex-direction: column;
    }

    p {
      display: block;
      margin: 0.35rem 0;
    }

    strong {
      margin: 0 0.35rem 0 0;
    }
  }

  .guest-plain-data__actions {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.35rem;
  }

  .guest-plain-data__hint {
    margin: 0;
    font-size: 0.85rem;
    color: #666;
    line-height: 1.4;
  }

  .guest-plain-data__hint-link {
    text-decoration: underline;
    cursor: pointer;
  }

  @media (max-width: 768px) {
    .info {
      flex-direction: column;
      align-items: center;
      text-align: center;
    }

    .profilePhoto {
      flex-basis: 140px;
      width: 140px;
      height: 140px;
    }

    .guest-plain-data__actions {
      align-items: center;
      width: 100%;
    }
  }
`;

const guestAge = (birthdate) => {
  if (!birthdate) return '';
  const years = moment().diff(birthdate, 'years');
  return Number.isFinite(years) ? years : '';
};

const GuestPlainData = ({ guest = {}, onGuestUpdated, highlightEdit = false }) => {
  const [editOpen, setEditOpen] = React.useState(false);
  const age = guestAge(guest.birthdate);

  return (
    <GuestPlainDataWrap className="guest-plain-data">
      <div className="info">
        {guest.photo && (
          <div className="profilePhoto" style={{ backgroundImage: `url(${guest.photo})` }} />
        )}
        <div className={`data ${guest.photo ? 'pic' : ''}`}>
          <p>
            <strong>Nombre:</strong>
            {guest.name}&nbsp;{guest.lastName}&nbsp;
          </p>
          <p>
            <strong>Género:</strong>
            {guest.gender}&nbsp;
          </p>
          {guest.civil && (
            <p>
              <strong>Estado civil:</strong>
              {guest.civil}&nbsp;
            </p>
          )}
          <p>
            <strong>Cédula:</strong>
            {guest.identification}&nbsp;
          </p>
          <p>
            <strong>Celular:</strong>
            {guest.phone}&nbsp;
          </p>
          <p>
            <strong>Email:</strong>
            {guest.email}&nbsp;
          </p>
          <p>
            <strong>Edad:</strong>
            {age}&nbsp;
          </p>
        </div>
      </div>
      <div className="guest-plain-data__actions">
        <p className="guest-plain-data__hint">
          Si tus datos están incompletos o incorrectos,{' '}
          <span onClick={() => setEditOpen(true)} className="guest-plain-data__hint-link">
            actualízalos aquí.
          </span>
        </p>
        <Button
          type="button"
          className="modify"
          size="mini"
          color={highlightEdit ? 'red' : undefined}
          onClick={() => setEditOpen(true)}
        >
          {GUEST_MISSING_DATA_BUTTON}
        </Button>
      </div>
      <EditGuestProfileModal
        open={editOpen}
        onClose={() => setEditOpen(false)}
        guest={guest}
        onUpdated={onGuestUpdated}
      />
    </GuestPlainDataWrap>
  );
};

export default GuestPlainData;
